var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEthLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 8.4667 8.4667",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.6801 4.3227 2.5345 1.5865 2.5573-1.5905-2.5477-4.3176z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.6894 4.8277 2.5345 1.5954 2.5573-1.5914-2.5477 3.6362z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEthLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eth_logo.2897b8d40943b25b1faaaaa9b36394f4.svg";